import type { FC, ReactElement } from 'react';

import useStyle from '@snowit/system/useStyle';
import { ButtonIcon } from '@snowit/ui';

interface IToggleColorMode {
  className?: string;
}

const ToggleColorMode: FC<IToggleColorMode> = (props: IToggleColorMode): ReactElement => {
  const { className } = props;
  const { theme, changeTheme } = useStyle();

  const handleClick = () => {
    changeTheme(theme === 'light' ? 'dark' : 'light');
  };

  return (
    <ButtonIcon
      classNames={{ button: className }}
      icon={theme === 'light' ? 'mode_light' : 'mode_dark'}
      onClick={handleClick}
      theme={'transparent'}
      size={'db'}
      color={'text'}
    />
  );
};

export default ToggleColorMode;
